<script>
export default {
  props: {
    etapas:     { type: Array,  default: () => [] },
    atual:      { type: Number, default: 1 },
    concluidas: { type: Array,  default: () => [] },
  },
  methods: {
    isConcluida(n) { return this.concluidas.includes(n) },
    isAtual(n)     { return n === this.atual },
    isFutura(n)    { return !this.isConcluida(n) && !this.isAtual(n) },
    isClicavel(n)  { return this.isConcluida(n) || this.isAtual(n) },
    clicar(n) {
      if (this.isClicavel(n)) this.$emit('ir-para', n)
    },
    ariaEtapa(etapa) {
      const label = etapa.label || ''
      const n = etapa.numero
      if (this.isConcluida(n)) return `Etapa ${n}: ${label}, concluída.`
      if (this.isAtual(n))     return `Etapa ${n}: ${label}, etapa atual.`
      return `Etapa ${n}: ${label}, ainda não disponível.`
    },
  },
}
</script>

<template>
  <ol class="stepper" aria-label="Etapas do cadastro">
    <li
      v-for="(etapa, idx) in etapas"
      :key="etapa.numero"
      class="stepper__item"
      :class="{
        'stepper__item--current': isAtual(etapa.numero),
        'stepper__item--done':    isConcluida(etapa.numero),
      }"
    >
      <span
        v-if="idx > 0"
        class="stepper__connector"
        :class="{ 'stepper__connector--done': isConcluida(etapas[idx - 1].numero) }"
        aria-hidden="true"
      />

      <button
        type="button"
        class="stepper__dot"
        :aria-current="isAtual(etapa.numero) ? 'step' : null"
        :aria-label="ariaEtapa(etapa)"
        :disabled="!isClicavel(etapa.numero)"
        @click="clicar(etapa.numero)"
      >
        <svg
          v-if="isConcluida(etapa.numero) && !isAtual(etapa.numero)"
          width="14"
          height="14"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
        >
          <path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span v-else>{{ etapa.numero }}</span>
      </button>

      <span class="stepper__label">{{ etapa.label }}</span>
    </li>
  </ol>
</template>

<style scoped>
.stepper {
  list-style: none;
  padding: 0;
  margin: 0 0 1.25rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.stepper__item {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 0 4px;
}

.stepper__connector {
  position: absolute;
  top: 15px;
  right: 50%;
  width: 100%;
  height: 2px;
  background: #ced4da;
  z-index: 0;
}

.stepper__connector--done {
  background: #23576E;
}

.stepper__dot {
  position: relative;
  z-index: 1;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #ced4da;
  background: #fff;
  color: #74788d;
  font-weight: 700;
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
  flex-shrink: 0;
  padding: 0;
  font-family: inherit;
  transition: background 0.15s, border-color 0.15s, color 0.15s, box-shadow 0.15s;
}

.stepper__dot:not(:disabled) {
  cursor: pointer;
}

.stepper__item--current .stepper__dot {
  background: #23576E;
  border-color: #23576E;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(35, 87, 110, 0.15);
}

.stepper__item--done:not(.stepper__item--current) .stepper__dot {
  background: #23576E;
  border-color: #23576E;
  color: #fff;
}

.stepper__label {
  margin-top: 0.5rem;
  font-size: 0.72rem;
  line-height: 1.2;
  color: #74788d;
  text-align: center;
  word-break: break-word;
  max-width: 100%;
}

.stepper__item--current .stepper__label {
  color: #212529;
  font-weight: 600;
}

.stepper__item--done:not(.stepper__item--current) .stepper__label {
  color: #23576E;
}

@media (min-width: 576px) {
  .stepper__label { font-size: 0.82rem; }
}

@media (min-width: 768px) {
  .stepper { margin-bottom: 1.5rem; }
  .stepper__label { font-size: 0.9rem; }
}
</style>
